export default __webpack_public_path__ + "static/media/Buhoro.aa3d321a.jpg";